import { isWorkspaceItem } from '@pn/core/domain/workspace';
import { workspaceActions } from '@pn/core/storage';
import React from 'react';

export function useListenForWorkspaceItems() {
  React.useEffect(() => {
    const listener = (event: MessageEvent<unknown>) => {
      const payload = event.data;

      if (isWorkspaceItem(payload)) {
        workspaceActions().add(payload, true);

        // Send acknowledgment back to opener
        if (window.opener) {
          window.opener.postMessage({ name: 'payloadReceived' }, event.origin);
        }
      }
    };

    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);
}
